import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD_PRIMITIVE__int } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__color_map extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.INVOCATION_IMAGE__COLOR_MAP;

  /*
   * FIELDS META
   */

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input_transform_none({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input({
    value: 64,
    value_range: new DTO__number_range(32, 256),
    values_allowed: new DTO__number_range(32, CONSTANTS_GENERATION__value_range.IMAGE_SIZE_IN.max),
    //
    multiple_of: 8,
    //
    slider_step: 32,
    slider_step_values: [8, 16, 32, 64, 128, 256],
  })
  tile_size!: FIELD_PRIMITIVE__int;

  /*
   * META
   */

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.COLOR_MAP }, { field_role: '🌈 Image Color Map' })
  out!: FIELD__image_asset;

  /*
   * PROPERTIES
   */

  get family() {
    return ENUM__ml_asset_family.VISION_CV2;
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.IMAGE__COLOR_MAP);
  }
}
